import { SearchBookingsRequest } from "@/models/api/SearchBookingsRequest";
import { BookingSummary } from "@/models/www/store/BookingSummary";
import accountService from "@/services/account.service";
import { ref } from "vue";

const bookings = ref<BookingSummary[]>([]);
const loading = ref(false);
const fetched = ref(false);

const useAccountBookings = () => {

    const fetchBookings = (req: SearchBookingsRequest) => {
        loading.value = true;
        accountService
            .getBookings(req)
            .then((resp) => (bookings.value = resp))
            .finally(() => {
                loading.value = false;
                fetched.value = true;
            });
    }

    return {
        bookings,
        fetchBookings,
        loading,
        fetched
    }
}

export default useAccountBookings;